const Header = () => {
    return (
        <header>
            <h1 className="logo">SPLI</h1>
            <h1 className="logo">TTER</h1>
        </header>
    )
}

export default Header
